export default {
  computed: {
    scopeAttrs() {
      // Get the scope attribute name (undefined if none)
      const scopeAttr = this.$parent.$options._scopeId;
      return scopeAttr ? { [scopeAttr]: "" } : {};
    }
  }
};